exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.start-button[data-v-c3c0c386] {\r\n  width: 100%;\r\n  text-align: center;\r\n  padding-top: 50px;\n}\nh6[data-v-c3c0c386] {\r\n  font-weight: 300;\n}\n.info-p[data-v-c3c0c386] {\r\n  font-size: 14px;\r\n  margin-top: 5px;\n}\r\n", ""]);

// exports
